import React from 'react';
import { placePageIconContainerClass } from '../../../data-catalog-shared';

export type PlacePageIconContainerProps = {
  readonly title: string;
};

export class PlacePageIconContainer extends React.Component<PlacePageIconContainerProps> {

  public override render(): JSX.Element {
    return (
      <div className={placePageIconContainerClass} title={this.props.title}>
        {this.props.children}
      </div>
    );
  }
}
